module.exports = __webpack_public_path__ + "static/media/logo_code.d0beabb3.jpg";